import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

let Guser = new Vuex.Store({
    state:{
        userId : "",
        hint:{txt:"",className:"",bl:false},
        view:false,
        title:"",
        super:false
    },
    mutations:{
        changUser (state,val) {
            state.userId = val
        },
        changeHint(state,val){
            state.hint = val
        },
        changeView(state,val){
            state.view = val
        },
        changeTitle(state,val){
            state.title = val
        },
        changeSuper(state,val){
            state.super = val
        }
    },
    getters:{
        getUser (state) {
            return state.userId
        },
        getHint(state){
            return state.hint
        },
        getView(state){
            return state.view
        },
        getTitle(state){
            return state.title
        },
        getSuper(state){
            return state.super
        }
    },
    actions:{
        setUser ({commit},val) {
            commit('changUser',val)
        },
        setHint({commit},val){
            commit('changeHint',val)
        },
        setView({commit},val){
            commit('changeView',val)
        },
        setTitle({commit},val){
            commit('changeTitle',val)
        },
        setSuper({commit},val){
            commit('changeSuper',val)
        }
    }
})

export default Guser;


// WEBPACK FOOTER //
// ./src/vuex/Guser.js